export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15012.9d2517d3.jpg";